<template>
    <div class="person-info">
        <div class="person-info-form" v-if="isEdit">
            <a-form-model
                layout="horizontal"
                :model="form"
                :labelCol="{ span: 4 }"
                :wrapperCol="{ span: 20 }"
                :rules="rules"
            >
                <a-form-model-item label="注册类型" prop="registerType">
                    <a-select v-model="form.registerType">
                        <a-select-option value="1">个人</a-select-option>
                        <a-select-option value="2">企业</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="姓名" prop="realName">
                    <a-input v-model="form.realName"> </a-input>
                </a-form-model-item>
                <a-form-model-item label="用户名" prop="userName">
                    <a-input v-model="form.userName"> </a-input>
                </a-form-model-item>
                <a-form-model-item label="手机号码" prop="phone">
                    <a-input v-model="form.phone" placeholder="请输入"> </a-input>
                </a-form-model-item>
                <a-form-model-item label="联系邮箱" prop="email">
                    <a-input v-model="form.email" placeholder="请输入"> </a-input>
                </a-form-model-item>
            </a-form-model>
            <div class="btns">
                <div class="btn" @click="cancel">取消</div>
                <div class="btn save" @click="update">保存</div>
            </div>
        </div>

        <div class="person-field-detail" v-else>
            <div class="info-item" v-for="item in filterInfo" :key="item.field">
                <span class="info-item-label">{{ item.label + ' : ' }}</span>
                <span class="info-item-val" v-if="item.field === 'registerType'">
                    {{ userInfo && userInfo.registerType == 1 ? '个人' : '企业' }}
                </span>
                <span class="info-item-val" v-else>{{ (userInfo && userInfo[item.field]) ?? '' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateUserInfo } from '../../../common/api';

export default {
    props: {
        isEdit: Boolean
    },
    data() {
        return {
            form: {
                registerType: '',
                realName: '',
                userName: '',
                phone: '',
                email: ''
            },
            rules: {},
            filterInfo: [
                { label: '注册类型', field: 'registerType' },
                { label: '姓名', field: 'realName' },
                { label: '用户名', field: 'userName' },
                { label: '手机号码', field: 'phone' },
                { label: '联系邮箱', field: 'email' }
            ]
        };
    },

    computed: {
        ...mapGetters(['userInfo'])
    },

    methods: {
        cancel() {
            this.$emit('backView');
        },

        async update() {
            await updateUserInfo({ ...this.form, id: this.userInfo.id }).then(res => {
                if (res.status === 200) {
                    this.$message.success('修改用户信息成功！');
                    this.$emit('backView');
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.person-info {
    margin-top: 16px;
    height: 648px;

    .person-info-form .btns {
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
        .btn {
            border: 1px solid rgba(217, 217, 217, 1);
            border-radius: 2px;
            width: 60px;
            height: 32px;
            margin-right: 16px;
            font-size: 14px;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }

        .save {
            background: #005299;
            color: #fff;
        }
    }
    .person-field-detail {
        margin-left: 125px;
        .info-item {
            margin-bottom: 16px;
            > span {
                height: 32px;
                line-height: 32px;
                display: inline-block;
            }

            &-label {
                width: 110px;
                text-align: right;
                padding-right: 16px;
            }

            &-placeholder {
                color: #999999;
                line-height: 20px;
            }
        }
    }
}
</style>
